import parse from "html-react-parser";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import { useAppSelector } from "../../redux/Store";
import { authDataSelector } from "../../redux/slice/AuthDataSlice";
import { ButtonSpinner } from "../placeholders";

type Props = {
	showModal: boolean;
	title: string;
	actionKey: "termsOfService" | "privacyPolicy" | "cookiesPolicy";
	onYesBtnClick: () => void;
	onYesBtnText?: string;
	isProcessing?: boolean;
};

const LongContentModal: React.FC<Props> = (props: Props) => {
	const {
		showModal,
		title,
		actionKey,
		onYesBtnClick,
		onYesBtnText = "Yes",
		isProcessing = false
	} = props;

	const { globalSettingsData } = useAppSelector(authDataSelector);

	return (
		<Modal show={showModal} centered size="lg" backdrop="static" className="content-modal">
			<Modal.Header>
				<Modal.Title className="h3">{title}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{actionKey === "termsOfService"
					? globalSettingsData?.TERMS_AND_CONDITIONS?.value &&
					  parse(globalSettingsData.TERMS_AND_CONDITIONS.value)
					: actionKey === "privacyPolicy"
					? globalSettingsData?.PRIVACY_POLICY?.value &&
					  parse(globalSettingsData.PRIVACY_POLICY.value)
					: actionKey === "cookiesPolicy"
					? globalSettingsData?.COOKIES_POLICY?.value &&
					  parse(globalSettingsData.COOKIES_POLICY.value)
					: null}
			</Modal.Body>
			<Modal.Footer className="modal-btns-wrap">
				<Button
					variant="secondary"
					onClick={onYesBtnClick}
					disabled={isProcessing}
					className="btn-w-120"
				>
					{!isProcessing ? onYesBtnText : <ButtonSpinner />}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default LongContentModal;
